var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0C0.447715 0 0 0.447715 0 0.999999V5.85714C0 6.40943 0.447715 6.85714 0.999999 6.85714H5.85714C6.40943 6.85714 6.85714 6.40943 6.85714 5.85714V1C6.85714 0.447715 6.40943 0 5.85714 0H1ZM11.7071 0.707107C11.3166 0.316583 10.6834 0.316582 10.2929 0.707106L7.70711 3.29289C7.31658 3.68342 7.31658 4.31658 7.70711 4.70711L10.2929 7.29289C10.6834 7.68342 11.3166 7.68342 11.7071 7.29289L14.2929 4.70711C14.6834 4.31658 14.6834 3.68342 14.2929 3.29289L11.7071 0.707107ZM0 9.14287C0 8.59059 0.447715 8.14287 1 8.14287H5.85714C6.40943 8.14287 6.85714 8.59059 6.85714 9.14287V14C6.85714 14.5523 6.40943 15 5.85714 15H0.999999C0.447715 15 0 14.5523 0 14V9.14287ZM9.14282 8.14288C8.59054 8.14288 8.14282 8.5906 8.14282 9.14288V14C8.14282 14.5523 8.59054 15 9.14282 15H14C14.5522 15 15 14.5523 15 14V9.14288C15 8.5906 14.5522 8.14288 14 8.14288H9.14282Z",
    fill: "#B5B7CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.ae97551357c56c131de45942b4a68361.svg";
export { ForwardRef as ReactComponent };